import React from "react";
import { Map, Swords, BookOpen, Castle } from "lucide-react";
import { screenshots } from "../data/mock";

const icons = [Map, Swords, BookOpen, Castle];
const hues = ["#2a75bb", "#ee1515", "#7fb12b", "#6c4ab6"];

const Showcase = () => {
  return (
    <section id="showcase" className="py-24 relative dotted-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="mono-pixel text-[#ffcb05] tracking-[0.3em] text-sm mb-3">// GAMEPLAY</p>
          <h2 className="pixel-font text-2xl sm:text-3xl text-white title-deco">EXPLORE EVERY MODE</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {screenshots.map((s, i) => {
            const Icon = icons[i];
            const hue = hues[i];
            return (
              <div
                key={i}
                className="feature-card group relative rounded-xl overflow-hidden border border-white/10 bg-white/[0.03]"
              >
                <div
                  className="aspect-[4/5] flex items-center justify-center scanline"
                  style={{
                    background: `linear-gradient(160deg, ${hue}33 0%, #0b1626 100%)`,
                  }}
                >
                  <Icon size={70} style={{ color: hue }} strokeWidth={1.5} />
                </div>
                <div className="p-5">
                  <h3 className="pixel-font text-[#ffcb05] text-xs mb-2">{s.title.toUpperCase()}</h3>
                  <p className="text-white/60 text-sm">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Showcase;
